import {first} from 'lodash';

export default {
  props: {
    appointment: {
      type: Object
    }
  },

  computed: {},

  data() {
    return {};
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Appointment/Detail/js/appointment-detail-header.js